import SupportedVehicles from '../class/SupportedVehicles';
import LazyloadImg from '../class/LazyloadImg';
import Tooltip from '../class/Tooltip';

new SupportedVehicles('data-makeid', '.wrapper-table-supported', '.js-feature-id', '/ajax/supported_vehicles.php').init();
new LazyloadImg('.lazy-load-img', 'data-listener-lazy-id', 'data-img-id').init()
new Tooltip('.tooltip-custom', '/ajax/feature_benefits.php').init()
